import { POINTS_TO_MIRAI_MILE_RATIO, YEN_TO_MIRAI_MILE_RATIO } from "./pointsToYen";

export const pointsToMiraiMile = (points: string | number, isDisplayedDecimal = false): string => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return points.toString();
  }

  const miraiMileValue = num * POINTS_TO_MIRAI_MILE_RATIO; // Convert points to yen
  if (isDisplayedDecimal) {
    if (miraiMileValue < 1) {
      return miraiMileValue.toFixed(1); // Return unrounded value with one decimal place
    }
  }

  return Math.floor(miraiMileValue).toLocaleString();
};

export const pointsToMiraiMileForCalculations = (points: string | number): number => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return 0;
  }
  const miraiMileValue = num * POINTS_TO_MIRAI_MILE_RATIO;
  return Math.floor(miraiMileValue);
};

export const yenToMiraiMile = (yen: number): number => {
  return Math.floor(yen * YEN_TO_MIRAI_MILE_RATIO);
};
